module.exports = __webpack_public_path__ + "images/top-losers-blue-938cd30e.svg";